/* src/app/shared/components/ag-drop-down/ag-multiple-section-box/ag-multiple-section-box.component.scss */
.container-standard {
  padding-left: 0px;
  position: relative;
  z-index: 2;
  max-height: 100%;
  height: fit-content;
  width: 100%;
  min-width: 82px;
  border-radius: 12px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  border: solid 1px #61566e;
  background-color: #ffffff;
  overflow: visible;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  margin-bottom: 8px;
}
::-webkit-scrollbar {
  width: 5px;
  display: none;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 3px;
  padding: 16px 13px;
}
.top-bottom-padding {
  padding: 8px 0;
  height: fit-content;
  position: relative;
  display: block;
  overflow-y: scroll;
  overflow-x: hidden;
}
.top-bottom-padding::-webkit-scrollbar-thumb {
  background-color: #a6a6a6;
  border-radius: 100px;
  width: 8px;
  height: 10px;
}
.top-bottom-padding::-webkit-scrollbar-track {
  background-color: #f2f2f2;
}
.item:hover {
  background-color: #f2f2f2;
}
.item {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 8px 16px;
}
.disabled-item {
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 8px 16px;
}
.hint-icon {
  position: absolute;
  top: 8px;
  right: 16px;
}
.hint-icon .tooltip-box {
  display: none;
  position: absolute;
  bottom: 24px;
  right: 0px;
  border-radius: 3px;
  padding: 2px 6px;
  background-color: #5c5c5c;
  z-index: 10;
}
.hint-icon .tooltip-box p {
  font-size: 12px !important;
  line-height: 18px !important;
  color: #ffffff !important;
}
.hint-icon img {
  width: 20px;
  height: 20px;
  filter: brightness(0) saturate(100%) invert(60%) sepia(97%) saturate(1930%) hue-rotate(198deg) brightness(89%) contrast(91%);
}
.hint-icon:hover .tooltip-box {
  display: flex !important;
}
/*# sourceMappingURL=ag-multiple-section-box.component.css.map */
